import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'
import { Lang } from '@owl-nest/api-client/latest'

import { Body } from './Body'
import { Toes } from './Toes'
import { Manifesto } from './Manifesto'

import { NavSection } from '../baseConfig'

type FooterProps = React.HTMLAttributes<HTMLDivElement> & {
  controlledCurrency?: string
  hasCurrencyAndLang?: boolean
  lang: Lang
  minimalMode?: boolean
  navSections: NavSection[]
  withRedirectParam?: boolean
}

function FooterComponent({
  controlledCurrency,
  lang,
  hasCurrencyAndLang = true,
  minimalMode = false,
  navSections,
  withRedirectParam,
  ...props
}: FooterProps): React.ReactElement<FooterProps> {
  return (
    <footer {...props}>
      <>
        {!minimalMode && (
          <>
            <Body
              controlledCurrency={controlledCurrency}
              $lang={lang}
              lang={lang}
              navSections={navSections}
              hasCurrencyAndLang={hasCurrencyAndLang}
              withRedirectParam={withRedirectParam}
            />
            <FooterSeparation />

            <Manifesto lang={lang} $lang={lang} />

            <FooterSeparation />
          </>
        )}
        <Toes $lang={lang} lang={lang} />
      </>
    </footer>
  )
}

const FooterSeparation = styled.hr`
  border-top: 1px solid ${plume.COLORS.PRIMARY_SAND_200};
  border-bottom: 0px;
  margin: 0;
`

export const Footer = styled(FooterComponent)`
  border-top: 1px solid ${plume.COLORS.PRIMARY_SAND_200};
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  box-sizing: border-box;
`
